<page-grid [gridConfig]="vendorsGrid" (gridClickColumn)="openDialog($event)" />